import PropertyAccordionContainer from "../../../components/property/detail/PropertyAccordion";

const PropertyAccordion = () => {
  return <PropertyAccordionContainer />;
};

export default PropertyAccordion;
